import React from "react";

// URL/email/phone detection — captures http(s):// URLs, bare www. URLs, and email addresses.
const PATTERN = /((?:https?:\/\/|www\.)[^\s<>"']+[^\s<>"'.,;!?)\]}])|([\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,})/gi;

/**
 * Renders a plain-text string with any URLs/emails converted into clickable <a> tags.
 * Safe against XSS — text is inserted via React, never as innerHTML.
 * Usage: <Linkify>{message.body}</Linkify>
 */
export default function Linkify({ children, className = "text-primary underline underline-offset-2 hover:text-primary/80" }) {
  const text = String(children ?? "");
  if (!text) return null;
  const parts = [];
  let lastIndex = 0;
  let match;
  const re = new RegExp(PATTERN.source, PATTERN.flags);
  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const raw = match[0];
    if (match[2]) {
      // Email
      parts.push(
        <a key={parts.length} href={`mailto:${raw}`} className={className}
           onClick={(e) => e.stopPropagation()}>
          {raw}
        </a>
      );
    } else {
      // URL — prefix bare www. with https://
      const href = raw.startsWith("http") ? raw : `https://${raw}`;
      parts.push(
        <a key={parts.length} href={href} target="_blank" rel="noopener noreferrer"
           className={className}
           onClick={(e) => e.stopPropagation()}>
          {raw}
        </a>
      );
    }
    lastIndex = match.index + raw.length;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return <>{parts}</>;
}
